<div *ngIf="checkingUpdate; else updateChecked">
  <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Comprobando actualizaciones...</p>
  </ngx-spinner>
</div>

<ng-template #updateChecked>
  <div *ngIf="authService.status >= 3">
    <div class="row justify-content-center"
      *ngIf="authService.isAuthenticated() && (authService.isAdmin || authService.roles === 'PartnerUser' || authService.roles.indexOf('PartnerUser') !== -1 || authService.roles === 'PartnerAgente' || authService.roles.indexOf('PartnerAgente') !== -1)"
      style="max-width: 100%;">
      <div class="col text-center" style="font-size: 20px">
        <strong>Este es tu QR para generar Leads. <br> Compártelo en caso de interés.</strong>
        <br>
        <qrcode [qrdata]="qrcode" [width]="200" [errorCorrectionLevel]="'M'"></qrcode>
      </div>
    </div>
    <div class="row col justify-content-center mt-5"
    *ngIf="authService.isAuthenticated() && (authService.isAdmin || authService.roles === 'PartnerUser' || authService.roles.indexOf('PartnerUser') !== -1 || authService.roles === 'PartnerAgente' || authService.roles.indexOf('PartnerAgente') !== -1)">
      <button mat-raised-button color="primary" (click)="newLead()" role="button" class="ml-4 mt-4 col-md-4 col-12"
        style="width: 10%; height: 5rem;">Alta de Lead</button>
      <button mat-raised-button color="primary" (click)="listLead()" role="button" class="ml-4 mt-4 col-md-4 col-12"
        style="width: 10%; height: 5rem;">Mis Leads</button>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-md-6 text-center" *ngIf="!authService.isAuthenticated()">
      <img src="assets/images/AF_MovProsAlarmas_Logo_RGB_POS.png" width="175" class="mb-4" alt="" />
      <h1 class="mt-5">{{title}}</h1>
      <p class="lead" *ngIf="!isTecalis">Esta acción requiere autorización. Por favor, inserte sus credenciales para
        continuar.</p>
      <p class="lead" *ngIf="isTecalis">Por favor espere, proceso de autentificación en curso</p>
      <p *ngIf="!isTecalis">
        <button class="btn btn-lg btn-primary" (click)="login()">Login</button>
      </p>
    </div>
  </div>


</ng-template>
